import React, {Component} from "react";
import {compose} from "redux";
import {withTranslation} from "react-i18next";
import SvGraphics from "../../assets/SvGraphics";
import CannabisPic from "../../assets/paris-flower.png";
import CannabisPic2 from "../../assets/togetherCannabis.jpg";
import CannabisPic3 from "../../assets/cannabisPic_5.jpg";
import MyTable from "../TableComponents/Table";


class PatientTreatmentPlansComposed extends Component {
    constructor(props) {
        super(props);
        this.state = {
            treatmentsExpand: [],
            treatmentsExpand2: [],
            lastTreatment: [],
            titrationSteps: [],
            stepsView: 0,
        };
    }

    componentDidMount() {
        let {allRequests} = this.props
        let {lastTreatment} = this.state
        let findIndex= allRequests.findIndex(item=> !!item.IsRequest)

        if (findIndex >=0 && allRequests.length>0){
            lastTreatment = allRequests[findIndex].Patient_treatments ? allRequests[findIndex].Patient_treatments : []
        }

        this.setState({lastTreatment})
    }

    onClickArrow = (index) => {
        let {treatmentsExpand} = this.state
        treatmentsExpand[index] = !treatmentsExpand[index]
        if (treatmentsExpand[index]) {
            this.getTitrationSteps(index, 0)
        }
        this.setState({treatmentsExpand})
    }

    getTitrationName = (treatment) => {
        let {titrationPlans} = this.props
        let language = localStorage.getItem('language')
        if (treatment.TreatmentSchedule === "Titration") {
            let findIndex = titrationPlans.findIndex(item => item.Titration_code === treatment.Titration_code)
            if (findIndex >= 0) {
                return language === "he" ? titrationPlans[findIndex].Titration_name_he : titrationPlans[findIndex].Titration_name
            }
        } else {
            let treatmentSchedule = treatment.TreatmentSchedule
            treatmentSchedule = treatmentSchedule === "As needed" && language === "he" ? "לפי צורך" : treatmentSchedule
            treatmentSchedule = treatmentSchedule === "Maintenance" && language === "he" ? "המשך טיפול" : treatmentSchedule
            return treatmentSchedule
        }

    }

    getProduct = (productID, key) => {
        let {Canabis_products} = this.props
        let result = ""
        if (productID) {
            let findIndex = Canabis_products.findIndex(item => item.Product_ID.toString() === productID)
            result = findIndex >= 0 ? Canabis_products[findIndex][key] : result
        }
        return result
    }

    getTitrationSteps = (index, stepsView) => {
        let {titrationPlans, t} = this.props
        let {lastTreatment} = this.state
        let treatment = lastTreatment[index]

        let findIndex = titrationPlans.findIndex(item => item.Titration_code === treatment.Titration_code)

        let language = localStorage.getItem('language')

        let titrationSteps = []
        if (findIndex >= 0) {
            let steps = titrationPlans[findIndex].Titration_steps
            let startFor = stepsView * 5
            let endFor = stepsView + 5 > steps.length ? steps.length : (stepsView * 5) + 5

            for (let i = startFor; i < endFor; i++) {
                titrationSteps.push(
                    <div style={{display: 'flex', position: 'relative'}} key={steps.Titration_step_ID}>
                        {startFor >= 5 && i === startFor && <div className={'patient_page_prev_div'}>
                            <SvGraphics svgname={language === "he" ? 'arrow-right-black' : 'arrow-left-black'}
                                        style={{width: '7px', height: '12px'}}
                                        onClick={() => this.getTitrationSteps(index, stepsView - 1)}/>
                        </div>}
                        <div className={'Patient_page_treatment_steps_block'}>
                            <div
                                className={'patient_page_treatments_step_label_index'}>{t('patient_boarding.Step')} {i + 1}</div>
                            <div style={{display: 'flex', width: '80%', justifyContent: 'space-between'}}>
                                <div className={"treatment-plan-icon-label-patientPage"}>
                                    <div className={"patient_page_treatment-plan-icon-back"}>
                                        <SvGraphics className={"patientPage_treatment-plan-icon"}
                                                    svgname={'morning-icon'}/>
                                    </div>
                                    <div className={"patientPage_treatment-plan-box-arguments"}>{steps[i].M}</div>
                                </div>
                                <div className={"treatment-plan-icon-label-patientPage"}>
                                    <div className={"patient_page_treatment-plan-icon-back"}>
                                        <SvGraphics className={"patientPage_treatment-plan-icon"}
                                                    svgname={'noon-icon'}/>
                                    </div>
                                    <div className={"patientPage_treatment-plan-box-arguments"}>{steps[i].N}</div>
                                </div>
                                <div className={"treatment-plan-icon-label-patientPage"}>
                                    <div className={"patient_page_treatment-plan-icon-back"}>
                                        <SvGraphics className={"patientPage_treatment-plan-icon"}
                                                    svgname={'evening-icon'}/>
                                    </div>
                                    <div className={"patientPage_treatment-plan-box-arguments"}>{steps[i].E}</div>
                                </div>
                            </div>
                        </div>
                        {i === endFor - 1 && steps.length !== endFor && <div className={'patient_page_next_div'}>
                            <SvGraphics svgname={language === "he" ? 'arrow-left-black' : 'arrow-right-black'}
                                        style={{width: '7px', height: '12px'}}
                                        onClick={() => this.getTitrationSteps(index, stepsView + 1)}/>
                        </div>}

                    </div>
                )
            }

        }
        this.setState({titrationSteps})
    }

    getVariety(treatment) {
        let language = localStorage.getItem('language')
        let variety = treatment.TreatmentVariety
        variety = variety === "Indica" && language === "he" ? "אינדיקה" : variety
        variety = variety === "Sativa" && language === "he" ? "סאטיבה" : variety
        variety = variety === "Blend" && language === "he" ? "זן היברידי" : variety
        variety = variety === "Select All" && language === "he" ? "אינדיקה, סאטיבה, זן היברידי" :
            variety === "Select All" && language === "en" ? "Indica, Sativa, Blend" : variety
        return variety
    }

    getIntakeMethod(treatment) {
        let language = localStorage.getItem('language')
        let intakeMethod = treatment.TreatmentIntakeMethod
        intakeMethod = intakeMethod === "Flower" && language === "he" ? "פרח" : intakeMethod
        intakeMethod = intakeMethod === "Oil drops" && language === "he" ? "טיפות שמן" : intakeMethod
        intakeMethod = intakeMethod === "Precision Dosing Devices" && language === "he" ? "משאף למינון מדוד" : intakeMethod
        intakeMethod = intakeMethod === "Other" && language === "he" ? "אחר" : intakeMethod


        return intakeMethod
    }

    render() {
        let {t, showDemo} = this.props
        let {treatmentsExpand, lastTreatment, titrationSteps} = this.state
        let treatmentToShow = []

        let test = [1]

        let stepsTemp = [1, 2, 3, 4, 5]

        let treatmentSteps = stepsTemp.map((item, index) =>
            <div style={{display: 'flex', position: 'relative'}}>
                {index === 0 && <div className={'patient_page_prev_div'}>
                    <SvGraphics svgname={'arrow-left-black'} style={{width: '7px', height: '12px'}}/>

                </div>}
                <div className={'Patient_page_treatment_steps_block'}>
                    <div
                        className={'patient_page_treatments_step_label_index'}>{t('patient_boarding.Step')} {index + 1}</div>
                    <div className={'patient_page_treatments_step_label'}>06-08/10/2020</div>
                    <div style={{display: 'flex', width: '80%', justifyContent: 'space-between'}}>
                        <div className={"treatment-plan-icon-label-patientPage"}>
                            <div className={"patient_page_treatment-plan-icon-back"}>
                                <SvGraphics className={"patientPage_treatment-plan-icon"} svgname={'morning-icon'}/>
                            </div>
                            <div className={"patientPage_treatment-plan-box-arguments"}>{index + 1}</div>
                        </div>
                        <div className={"treatment-plan-icon-label-patientPage"}>
                            <div className={"patient_page_treatment-plan-icon-back"}>
                                <SvGraphics className={"patientPage_treatment-plan-icon"} svgname={'noon-icon'}/>
                            </div>
                            <div className={"patientPage_treatment-plan-box-arguments"}>{index + 1}</div>
                        </div>
                        <div className={"treatment-plan-icon-label-patientPage"}>
                            <div className={"patient_page_treatment-plan-icon-back"}>
                                <SvGraphics className={"patientPage_treatment-plan-icon"} svgname={'evening-icon'}/>
                            </div>
                            <div className={"patientPage_treatment-plan-box-arguments"}>{index + 1}</div>
                        </div>
                    </div>
                </div>
                {index === stepsTemp.length - 1 && <div className={'patient_page_next_div'}>
                    <SvGraphics svgname={'arrow-left-black'}
                                style={{width: '7px', height: '12px', transform: 'rotate(180deg)'}}/>
                </div>}

            </div>
        )

        let language = localStorage.getItem('language')


        treatmentToShow = lastTreatment.map((item, index) =>
            <div className={'Patient_Page_tratments_block'} style={{backgroundColor: '#fafafa'}} key={item.Treatment_ID}>
                <div className={'Patient-Page-treatment'}>
                    <img src={CannabisPic3} width={'46px'} height={'46px'} style={{margin: '0 10px'}} alt={""}/>
                    <div className={'patientPage_TreatmentPlan_values_block'}>
                        <div className={'patientPage_TreatmentPlan_values'}
                             style={{color: '#005f7f'}}>{this.getProduct(item.Product_ID, "Product_name")}</div>
                        <div
                            className={'patientPage_TreatmentPlan_values'}>{this.getProduct(item.Product_ID, "Brand")}</div>
                        <div className={'patientPage_TreatmentPlan_values'}>{this.getVariety(item)}</div>
                        <div className={'patientPage_TreatmentPlan_values'}> {this.getIntakeMethod(item)}</div>
                        <div className={'patientPage_TreatmentPlan_values'}>{item.TreatmentCategory}</div>
                        <div className={'patientPage_TreatmentPlan_values'} style={{color: '#005f7f'}}>{item.Symptom_ID}
                        </div>

                        <div className={'patientPage_TreatmentPlan_values'}>{this.getTitrationName(item)}</div>

                        {item.TreatmentSchedule === "Titration" && <SvGraphics
                            className={!treatmentsExpand[index] ? "patient-page-arrow" : "patient-page-arrow-rotate"}
                            width={"15px"} height={"15px"} svgname={'arrow-down'}
                            onClick={() => this.onClickArrow(index)}/>}
                    </div>
                </div>

                {treatmentsExpand[index] &&
                <div style={{display: 'block', width: '100%'}}>
                    <div className={'Patient-Page-treatments-steps'}>
                        {titrationSteps}
                    </div>
                </div>
                }
            </div>
        )


        let treatments = test.map((item, index) =>
            <div className={'Patient_Page_tratments_block'} style={{backgroundColor: '#fafafa'}}>
                <div className={'Patient-Page-treatment'}>
                    <img src={CannabisPic3} width={'46px'} height={'46px'} style={{margin: '0 10px'}} alt={""}/>
                    <div className={'patientPage_TreatmentPlan_values_block'}>
                        <div className={'patientPage_TreatmentPlan_values'} style={{color: '#005f7f'}}>מאי</div>
                        <div className={'patientPage_TreatmentPlan_values'}>טוגדר פארמה</div>
                        <div className={'patientPage_TreatmentPlan_values'}>אינדיקה</div>
                        <div className={'patientPage_TreatmentPlan_values'}> פרח</div>
                        <div className={'patientPage_TreatmentPlan_values'}>T15/C3</div>
                        <div className={'patientPage_TreatmentPlan_values'} style={{color: '#005f7f'}}>הפרעות שינה, כאב
                            כרוני
                        </div>
                        <div className={'patientPage_TreatmentPlan_values'}>לילה נאיבי</div>
                        <div className={'patientPage_TreatmentPlan_values'}
                             style={{minWidth: '170px', color: '#005f7f'}}>Change Product
                        </div>
                        <SvGraphics
                            className={!treatmentsExpand[index] ? "patient-page-arrow" : "patient-page-arrow-rotate"}
                            width={"15px"} height={"15px"} svgname={'arrow-down'}
                            onClick={() => this.onClickArrow(index)}/>
                    </div>
                </div>

                {treatmentsExpand[index] &&
                <div style={{display: 'block', width: '100%'}}>
                    <div className={'Patient-Page-treatments-steps'}>
                        {treatmentSteps}

                    </div>
                </div>

                }
            </div>
        )


        return (
            <div>
                <div className={'patientPage_TreatmentPlan_titles'}>
                    <div className={'patientPage_TreatmentPlan_titles_label'}>{t('patientPage.Product')}</div>
                    <div className={'patientPage_TreatmentPlan_titles_label'}>{t('patientPage.Brand')}</div>
                    <div className={'patientPage_TreatmentPlan_titles_label'}>{t('patientPage.Variety')}</div>
                    <div className={'patientPage_TreatmentPlan_titles_label'}>{t('patientPage.IntakeMethod')}</div>
                    <div className={'patientPage_TreatmentPlan_titles_label'}>{t('patientPage.Category')}</div>
                    <div className={'patientPage_TreatmentPlan_titles_label'}>{t('patientPage.Symptoms')}</div>
                    <div className={'patientPage_TreatmentPlan_titles_label'}>{t('patientPage.Titration')}</div>
                </div>
                {!showDemo && treatmentToShow}
                {showDemo && treatments}
                {showDemo && treatments}


            </div>

        );
    }
}


const PatientTreatmentPlans = compose(
    withTranslation(),
)(PatientTreatmentPlansComposed);

export default PatientTreatmentPlans;

